<div class="row h-100 w-100 m-0">

<div class="image-width p-0 " style="z-index: 3;">
	<div class="image-side"></div>
</div>
<div class="header-width header-zone">
<app-header hideLeftButtons="true"></app-header>
<main>
	<div class="container-new">
		<div class="inner-frame">
			<h1 *ngIf="!isAdvisor" class="h1">{{'END.TITLE_0'|translate}}</h1>
			<h1 *ngIf="!isAdvisor" class="h1">{{'END.TITLE_1'|translate}}</h1>
			<h1 *ngIf="isAdvisor" class="h1">{{'END.TITLE_1-ADVISOR'|translate}}</h1>

			<div class="asmahta">{{'END.MSG_1'|translate}} {{asmachta$|async}}</div>

			<div class="paragraph1">
				<span>{{'END.MSG_2_1'|translate}}</span>
				<span class="font-weight-bold">{{'END.MSG_2_bold1'|translate}}</span>
			</div>
			<div class="paragraph1">
				<span>{{'END.MSG_2_2'|translate}}</span>
				<span class="font-weight-bold">{{'END.MSG_2_bold2'|translate}}</span>
			</div>
			<div class="paragraph1">
				<span>{{'END.MSG_2_3'|translate}}</span>
			</div>

			<h2 class="margin-top-2 margin-bottom-2">{{'END.MSG_4'|translate}}</h2>

			<div class="logos">
				<div class="">
					<a href="https://apps.apple.com/il/app/id1597126178" #lnkAppstor [attr.aria-label]="'END.LINK_APPLE_STORE' | translate">
						<img src="assets/app-images/components-badge-appstore@3x.png" [alt]="'END.LINK_APPLE_STORE' | translate" />
					</a>
				</div>
				<div class="">
					<a href="https://play.google.com/store/apps/details?id=com.MizrahiTefahot.mj&hl=iw&gl=US" #lnkGooglePlay [attr.aria-label]="'END.LINK_GOOGLE_PLAY' | translate">
						<img src="assets/app-images/components-badge-google-play@3x.png" [alt]="'END.LINK_GOOGLE_PLAY' | translate" />
					</a>    
				</div>
			</div>

			<h2 class="margin-top-2 margin-bottom-2">{{'END.TITLE_2'|translate}}</h2>

			<div class="hatavot">
				<ul>
					<li *ngFor="let allowsYou of allowsYouList">{{allowsYou}}</li>
				</ul>
			</div>
		</div>
	</div>
	
	
</main>
</div>




// WEBPACK FOOTER //
// ./src/app/end-page/end-page.component.html